import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { CAMPUS_API } from "../../common/Constants";
import HttpUtil from "../../common/HttpUtil";
import DefaultAlert from "../DefaultAlert";
import TableList from "../../common/TableList";
import { STATUS_LIST_OBJECT } from "../../common/LookupConstants";
import Can from "../../../auth/can";

class CampusList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campusList: null,

      //Default alert
      showAlert: false,
      alertMode: "",
      alertMessage: ""
    };
  }

  componentDidMount() {
    this.getCampusList();
  }

  handleApiSuccess = data => {
    this.setState({
      campusList: data
    });
  };

  handleApiFailed = message => {
    this.setState({
      showAlert: true,
      alertMode: "danger",
      alertMessage: message
    });
  };

  getCampusList = () => {
    const url = CAMPUS_API;
    const authToken = this.props.authToken;
    const headers = {
      "Content-Type": "application/json",
      Authorization: authToken
    };

    HttpUtil.get(
      url,
      headers,
      data => this.handleApiSuccess(data),
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  closeDefaultAlert = () => {
    this.setState({
      showAlert: false,
      alertMode: "",
      alertMessage: ""
    });
  };

  linkFormater = (cell, row) => {
    if (!row) {
      return null;
    }
    let campusId = row._id;
    const url = `/admin/campuses/edit/${campusId}`;
    return <Link to={url}>{row.name}</Link>;
  };

  getCampusName = (cell, row) => {
    if (!row) {
      return null;
    }
    return row.name;
  };

  render() {
    const {
      campusList,

      //Default alert
      showAlert,
      alertMode,
      alertMessage
    } = this.state;

    const columnsCampus = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: this.linkFormater,
        csvFormatter: this.getCampusName,
        filterValue: this.getCampusName
      },
      {
        dataField: "status",
        text: "Status",
        formatter: cell => STATUS_LIST_OBJECT[cell],
        csvFormatter: cell => STATUS_LIST_OBJECT[cell],
        filterValue: cell => STATUS_LIST_OBJECT[cell]
      }
    ];

    return (
      <Fragment>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            {/* show alert message  */}
            <DefaultAlert
              show={showAlert}
              alertMode={alertMode}
              message={alertMessage}
              closeAlert={this.closeDefaultAlert}
            />
          </div>
        </div>

        <TableList
          keyField="_id"
          columns={columnsCampus}
          data={campusList}
          noDataIndication="No Campus found."
          sizePerPage="5"
          headerName="Campus"
          showSearchbar={true}
          customComponent={<RenderCustomButton />}
        />
      </Fragment>
    );
  }
}
export default CampusList;

const RenderCustomButton = props => {
  return (
    <Can I="CREATE" a="Campus">
      <Link
        to="/admin/campuses/add"
        role="button"
        className="btn btn-sm text-white bg-pink"
      >
        New
      </Link>
    </Can>
  );
};
